/*
  SwiftMoto: product page tracking for Google Analytics 4.

  Sends product page clicks to GA4 through the Google tag that the
  Google & YouTube app already puts on every page, so the events sit in the
  same visit as the app's own view_item and add_to_cart. Events go to the
  GA4 ID in Theme settings > Product page tracking only (not Google Ads or
  Merchant Center). Nothing is sent when the Google tag isn't on the page
  (for example an ad blocker) or in the theme editor.

  Every event carries:
    product    the product's handle (the name in its web address), which
               stays the same on the English and Malay sites
    step       what the shopper just did, e.g. "Free Delivery: open",
               "Size XS: sold out", "Exit: collection"
    prev_step  what they did just before it on this product page
               ("Page loaded" when it's the first thing they do)
  So "what do shoppers do after opening Free Delivery" is every event with
  prev_step "Free Delivery: open", grouped by step.

  Events:
    pdp_section_toggle  a concertina opened or closed (section, action)
    pdp_option_select   a size or colour picked (option, value, in_stock)
    pdp_size_guide      Size Guide opened, or cm / in switched (action)
    pdp_help_click      chat, email, phone or WhatsApp link clicked (method)
    pdp_image           image zoom, thumbnail, swipe, or swipe in the photo
                        viewer on phones (action: viewer_swipe)
    pdp_quantity        quantity plus, minus or typed (action)
    select_item         a product clicked in a related products list
                        (GA4's standard event: item_list_name, items)
    pdp_exit            the shopper left the page: clicked through, went
                        back, closed the tab or switched app (exit_to,
                        sold_out_picked, added_to_cart, opened, steps_taken)
    pdp_return          the shopper came back to the page after a pdp_exit
                        (exit_to says which exit it follows)

  Add to cart is not sent here because the Google & YouTube app already
  sends add_to_cart. This script sets prev_step on the page's Google tag, so
  the app's add_to_cart also carries the step that came before it.
  Repeats of the same step in a row (several swipes, several plus taps) are
  sent once.
*/
(function () {
  'use strict';

  if (window.SMPdpTracking) return;

  var cfgEl = document.getElementById('pdp-tracking-config');
  if (!cfgEl) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  if (!cfg || !cfg.ga4) return;

  var root = cfgEl.closest('.shopify-section') || document.body;
  var NOT_MAIN = 'product-card, .card, product-recommendations, quick-view-drawer, .quick-view-drawer';
  var SWITCHED_AWAY = 'back, close or switched away';
  var MAX_EVENTS = 150;

  var state = {
    last: 'Page loaded',
    steps: 0,
    sent: 0,
    soldOut: false,
    added: false,
    opened: [],
    seen: document.visibilityState === 'visible',
    exited: false,
    exitTo: '',
    intent: null,
    pendingOption: null,
    optionTimer: null
  };

  window.SMPdpTracking = { version: 1, state: state };

  /* ---------- sending ---------- */

  function clip(value) {
    var text = String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
    return text.length > 100 ? text.slice(0, 100) : text;
  }

  function send(name, params) {
    if (typeof window.gtag !== 'function') return;
    if (state.sent >= MAX_EVENTS) return;
    var payload = { send_to: cfg.ga4, product: clip(cfg.product) };
    for (var key in params) {
      if (!Object.prototype.hasOwnProperty.call(params, key)) continue;
      var value = params[key];
      if (value === undefined || value === null || value === '') continue;
      payload[key] = typeof value === 'string' ? clip(value) : value;
    }
    try {
      window.gtag('event', name, payload);
      state.sent++;
    } catch (e) {}
  }

  // Lets the Google & YouTube app's own events (add_to_cart, view_cart)
  // carry the step that came before them.
  function setPrevOnTag(label) {
    if (typeof window.gtag !== 'function') return;
    try {
      window.gtag('set', { prev_step: label });
    } catch (e) {}
  }

  // A step is something the shopper did. It's sent with the step before
  // it, then becomes the "previous step" for whatever happens next.
  function step(name, label, params) {
    label = clip(label);
    if (!label || label === state.last) return;
    params = params || {};
    params.step = label;
    params.prev_step = state.last;
    send(name, params);
    state.last = label;
    state.steps++;
    setPrevOnTag(label);
  }

  function safe(fn) {
    return function (event) {
      try {
        fn(event);
      } catch (e) {}
    };
  }

  function inMain(el) {
    return el && root.contains(el) && !el.closest(NOT_MAIN);
  }

  /* ---------- concertinas ---------- */

  function sectionName(toggle) {
    var span = toggle.querySelector('span');
    if (!span) return clip(toggle.textContent) || 'Section';
    var copy = span.cloneNode(true);
    copy.querySelectorAll('.facet-toggle-count, .visually-hidden').forEach(function (node) {
      node.remove();
    });
    return clip(copy.textContent) || 'Section';
  }

  function onSectionToggle(toggle) {
    var name = sectionName(toggle);
    setTimeout(
      safe(function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        var action = open ? 'open' : 'close';
        if (open && state.opened.indexOf(name) === -1) state.opened.push(name);
        step('pdp_section_toggle', name + ': ' + action, { section: name, action: action });
      }),
      0
    );
  }

  /* ---------- size and colour ---------- */

  function stockLabel(inStock) {
    if (inStock === 'yes') return 'in stock';
    if (inStock === 'no') return 'sold out';
    return 'not available';
  }

  function flushOption(inStock) {
    var pending = state.pendingOption;
    if (!pending) return;
    state.pendingOption = null;
    clearTimeout(state.optionTimer);
    if (!inStock) inStock = pending.fallback;
    if (inStock === 'no') state.soldOut = true;
    step('pdp_option_select', pending.option + ' ' + pending.value + ': ' + stockLabel(inStock), {
      option: pending.option,
      value: pending.value,
      in_stock: inStock
    });
  }

  function onOptionChange(input) {
    var option = '';
    var value = input.value;
    var fallback = '';
    if (input.tagName === 'SELECT') {
      var wrap = input.closest('.product-form-input');
      var label = wrap && wrap.querySelector('label');
      option = label ? label.textContent : input.name.replace(/^options\[|\]$/g, '');
      var chosen = input.options[input.selectedIndex];
      fallback = chosen ? chosen.getAttribute('data-variant-available') : '';
    } else {
      var fieldset = input.closest('fieldset');
      option = (fieldset && fieldset.getAttribute('data-option-name')) || input.name;
      fallback = input.getAttribute('data-variant-available');
    }
    // A pick that hasn't been sent yet (the theme was still loading the
    // last variant) goes out first with its own stock status.
    if (state.pendingOption) flushOption();
    state.pendingOption = {
      option: clip(option),
      value: clip(value),
      fallback: fallback === 'true' ? 'yes' : fallback === 'false' ? 'no' : 'unknown'
    };
    // The theme fires product:variant-change with the chosen variant once it
    // has loaded; if that doesn't arrive, use the stock flag on the button.
    state.optionTimer = setTimeout(safe(function () { flushOption(); }), 2500);
  }

  /* ---------- image slider swipes ---------- */

  var sliderHooked = false;
  function hookSlider() {
    if (sliderHooked) return;
    var gallery = root.querySelector('media-gallery');
    var flickity = gallery && gallery.flickity;
    if (!flickity || typeof flickity.on !== 'function') return;
    sliderHooked = true;
    var dragAt = 0;
    flickity.on('dragStart', function () {
      dragAt = Date.now();
    });
    flickity.on(
      'change',
      safe(function () {
        // Only swipes count. The theme also moves the slider itself when a
        // colour is picked; that has no drag before it.
        if (Date.now() - dragAt < 3000) step('pdp_image', 'Image: swipe', { action: 'swipe' });
      })
    );
  }

  /* ---------- where a click is going ---------- */

  function plainPath(path) {
    return path.replace(/^\/ms(?=\/|$)/, '') || '/';
  }

  function destination(href) {
    var url;
    try {
      url = new URL(href, location.href);
    } catch (e) {
      return '';
    }
    if (!/^https?:$/.test(url.protocol)) return '';
    if (url.host !== location.host) {
      return /shopify|checkout|shop\.app/.test(url.host) ? 'checkout' : 'other site';
    }
    var path = plainPath(url.pathname);
    if (url.pathname === location.pathname && url.search === location.search) return '';
    if (path === plainPath(location.pathname)) return 'same product';
    if (/\/products\//.test(path)) return 'another product';
    if (/^\/collections(\/|$)/.test(path)) return 'collection';
    if (/^\/cart(\/|$)/.test(path)) return 'cart';
    if (/^\/checkouts?(\/|$)/.test(path)) return 'checkout';
    if (/^\/search(\/|$)/.test(path)) return 'search';
    if (/^\/pages\//.test(path)) return 'info page';
    if (/^\/policies\//.test(path)) return 'policy page';
    if (/^\/blogs\//.test(path)) return 'blog';
    if (/^\/account(\/|$)/.test(path)) return 'account';
    if (path === '/') return 'home';
    return 'other page';
  }

  /* ---------- related products ---------- */

  function headingText(el, selector) {
    var heading = el && el.querySelector(selector);
    return heading ? clip(heading.textContent) : '';
  }

  function listName(link) {
    if (root.contains(link)) {
      var block = link.closest('product-recommendations');
      if (block) return headingText(block, '.block-heading') || 'Frequently bought together';
      if (link.closest('[id*="bogos"], [class*="bogos"]')) return 'BOGOS offer';
      if (link.closest('.product-info-description, .product-info-wrap-content')) return 'Link in product info';
      return '';
    }
    var section = link.closest('.shopify-section');
    if (!section) return '';
    var id = section.id || '';
    if (/product-recommendations|related/.test(id)) {
      return headingText(section, '.section-heading') || 'You may also like';
    }
    if (/recently-viewed/.test(id)) return headingText(section, '.section-heading') || 'Recently viewed';
    return '';
  }

  function onProductLink(link) {
    var list = listName(link);
    if (!list) return;
    var url;
    try {
      url = new URL(link.href, location.href);
    } catch (e) {
      return;
    }
    var match = url.pathname.match(/\/products\/([^/?#]+)/);
    if (!match || match[1] === cfg.handle) return;
    var card = link.closest('product-card, .card, .grid-item, li');
    var title =
      headingText(card, '.card-title, [class*="card-title"], .product-card-title') ||
      clip(link.getAttribute('aria-label') || link.textContent) ||
      match[1];
    step('select_item', 'Related: ' + list, {
      item_list_name: list,
      items: [{ item_id: match[1], item_name: title }]
    });
  }

  /* ---------- leaving and coming back ---------- */

  function onHidden() {
    if (state.exited || !state.seen) return;
    if (state.pendingOption) flushOption();
    var intent = state.intent;
    var dest = intent && Date.now() - intent.at < 8000 ? intent.dest : SWITCHED_AWAY;
    state.exited = true;
    state.exitTo = dest;
    send('pdp_exit', {
      step: 'Exit: ' + dest,
      prev_step: state.last,
      exit_to: dest,
      sold_out_picked: state.soldOut ? 'yes' : 'no',
      added_to_cart: state.added ? 'yes' : 'no',
      opened: state.opened.length ? state.opened.join(' | ') : 'none',
      steps_taken: state.steps
    });
  }

  function onVisible() {
    state.seen = true;
    if (!state.exited) return;
    state.exited = false;
    send('pdp_return', {
      step: 'Returned to page',
      prev_step: state.last,
      exit_to: state.exitTo
    });
    state.intent = null;
  }

  /* ---------- listeners ---------- */

  // Clicks inside the product section.
  root.addEventListener(
    'click',
    safe(function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var toggle = target.closest('collapsible-expandable .facet-toggle');
      if (toggle && inMain(toggle)) {
        onSectionToggle(toggle);
        return;
      }

      var guide = target.closest('.sg-inline-link, .content-drawer-button');
      if (guide && inMain(guide)) {
        step('pdp_size_guide', (clip(guide.textContent) || 'Size Guide') + ': open', { action: 'open' });
        return;
      }

      var zoom = target.closest('modal-opener');
      if (zoom && inMain(zoom)) {
        step('pdp_image', 'Image: zoom', { action: 'zoom' });
        return;
      }

      var thumb = target.closest('.product-media-thumbnail');
      if (thumb && inMain(thumb)) {
        step('pdp_image', 'Image: thumbnail', { action: 'thumbnail' });
        return;
      }

      var qtyButton = target.closest('quantity-input button');
      if (qtyButton && inMain(qtyButton)) {
        var dir = qtyButton.getAttribute('name') === 'minus' ? 'minus' : 'plus';
        step('pdp_quantity', 'Quantity: ' + dir, { action: dir });
        return;
      }

      var link = target.closest('a[href]');
      if (link && inMain(link)) {
        var href = link.getAttribute('href') || '';
        var method = /^mailto:/i.test(href)
          ? 'email'
          : /#chat$/i.test(href)
            ? 'chat'
            : /^tel:/i.test(href)
              ? 'phone'
              : /wa\.me|whatsapp/i.test(href)
                ? 'whatsapp'
                : '';
        if (method) step('pdp_help_click', 'Help: ' + method, { method: method });
      }

      hookSlider();
    })
  );

  root.addEventListener(
    'pointerdown',
    safe(function () {
      hookSlider();
    }),
    true
  );

  // Size and colour picks, and a quantity typed in.
  root.addEventListener(
    'change',
    safe(function (event) {
      var input = event.target;
      if (!input || !input.closest) return;
      var picker = input.closest('variant-radios, variant-selects');
      if (picker && inMain(picker) && (input.type === 'radio' || input.tagName === 'SELECT')) {
        onOptionChange(input);
      }
    })
  );

  root.addEventListener(
    'input',
    safe(function (event) {
      var input = event.target;
      if (input && input.closest && input.closest('quantity-input') && inMain(input)) {
        step('pdp_quantity', 'Quantity: typed', { action: 'typed' });
      }
    })
  );

  document.addEventListener(
    'product:variant-change',
    safe(function (event) {
      if (!state.pendingOption) return;
      var variant = event.detail && event.detail.variant;
      flushOption(variant ? (variant.available ? 'yes' : 'no') : 'not available');
    })
  );

  // Swipes between photos in the photo viewer (phones and tablets). The
  // viewer sits outside the section, so the theme reports them with an
  // event (assets/product-modal.js).
  document.addEventListener(
    'product:modal-swipe',
    safe(function (event) {
      var detail = event.detail || {};
      if (root.id && detail.sectionId && root.id !== 'shopify-section-' + detail.sectionId) return;
      step('pdp_image', 'Image: viewer swipe', { action: 'viewer_swipe' });
    })
  );

  // Size Guide cm / in switch (the drawer can sit outside the section).
  document.addEventListener(
    'click',
    safe(function (event) {
      var button = event.target && event.target.closest && event.target.closest('.sg-units button[data-sg-set]');
      if (!button) return;
      var unit = button.getAttribute('data-sg-set');
      step('pdp_size_guide', 'Size Guide: ' + unit, { action: unit });
    })
  );

  // Related product clicks, and where any link click is heading.
  document.addEventListener(
    'click',
    safe(function (event) {
      var link = event.target && event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      if (/\/products\//.test(link.getAttribute('href') || '')) onProductLink(link);
      if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if ((link.getAttribute('target') || '') === '_blank') return;
      if (/#chat$/i.test(link.getAttribute('href') || '')) return;
      var dest = destination(link.href);
      if (dest) state.intent = { dest: dest, at: Date.now() };
    }),
    true
  );

  document.addEventListener(
    'submit',
    safe(function (event) {
      var form = event.target;
      var action = (form && form.getAttribute && form.getAttribute('action')) || '';
      if (/\/cart\/add/.test(action)) return;
      var submitter = event.submitter;
      var dest = /\/search/.test(action)
        ? 'search'
        : /\/cart/.test(action)
          ? submitter && submitter.name === 'checkout'
            ? 'checkout'
            : 'cart'
          : '';
      if (dest) state.intent = { dest: dest, at: Date.now() };
    }),
    true
  );

  // Added to cart: kept as a step so later events show it came first. Not
  // sent as an event (the Google & YouTube app sends add_to_cart).
  document.addEventListener(
    'cart:item-add',
    safe(function (event) {
      var items = (event.detail && event.detail.items) || [];
      var mine = items.some(function (item) {
        return item && String(item.product_id) === String(cfg.productId);
      });
      if (mine) state.added = true;
      var label = mine ? 'Added to cart' : 'Added related product to cart';
      if (label !== state.last) {
        state.last = label;
        state.steps++;
      }
    })
  );

  // Capture listeners on window run before other page scripts react to the
  // page being hidden, so the exit event is queued while it can still go.
  window.addEventListener(
    'visibilitychange',
    safe(function () {
      if (document.visibilityState === 'hidden') onHidden();
      else onVisible();
    }),
    true
  );
  window.addEventListener('pagehide', safe(onHidden), true);
  window.addEventListener(
    'pageshow',
    safe(function (event) {
      if (event.persisted) onVisible();
    }),
    true
  );

  setPrevOnTag('Page loaded');
  hookSlider();
  window.addEventListener(
    'load',
    safe(function () {
      setPrevOnTag(state.last);
      hookSlider();
    })
  );
})();
